import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LINKS } from '../config/siteLinks';

export default function ShopifyLogin() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const installed = searchParams.get('installed');
  const shop = searchParams.get('shop');

  if (installed === 'true' && shop) {
    setTimeout(() => {
      navigate('/dashboard');
    }, 2000);

    return (
      <div className="min-h-screen flex items-center justify-center" style={{background: '#0B1120'}}>
        <div className="text-center">
          <div className="w-16 h-16 bg-[#8CF78E]/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-[#8CF78E]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Shopify App Installed!</h2>
          <p className="text-[#9CB0C7]">Redirecting to dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center" style={{background: '#0B1120'}}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white mb-2">Commerce Index</h1>
          <p className="text-[#9CB0C7]">Shopify App Installation</p>
        </div>

        <div className="rounded-lg border border-[#22304A] bg-[#0E1426]/80 backdrop-blur p-8 shadow-[0_0_0_1px_rgba(62,241,199,0.06)]">
          <h2 className="text-2xl font-semibold text-white mb-4">Install Commerce Index</h2>
          <p className="text-[#9CB0C7] mb-6">
            Install Commerce Index directly from the Shopify App Store to get started with automatic product syncing and intelligent deal management.
          </p>

          <a
            href={LINKS.shopifyInstallUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full py-3 bg-[#96bf48] text-white rounded-lg hover:bg-[#96bf48]/90 transition-colors font-bold flex items-center justify-center gap-2"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
            Install from Shopify App Store
          </a>

          <div className="mt-6 p-4 bg-[#7A5CFF]/10 border border-[#7A5CFF]/20 rounded-lg">
            <p className="text-sm text-[#9CB0C7]">
              <strong className="text-white">What happens next:</strong><br/>
              1. You'll be redirected to the Shopify App Store<br/>
              2. Click "Add app" and review permissions<br/>
              3. Automatically sync your products<br/>
              4. Start creating AI-powered deals!
            </p>
          </div>

          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/login')}
              className="text-sm text-[#3EF1C7] hover:text-[#3EF1C7]/80"
            >
              ← Back to Standard Login
            </button>
          </div>
        </div>

        <div className="mt-6 text-center">
          <p className="text-sm text-[#9CB0C7]">
            Don't have a Shopify store?{' '}
            <button
              onClick={() => navigate('/merchant/login')}
              className="text-[#3EF1C7] hover:text-[#3EF1C7]/80 font-semibold"
            >
              Sign up as standalone merchant
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
